import React, { Component } from "react";
import { Collapse, Typography } from "antd";
import styles from "./faqs.module.css";

class FAQs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: 1,
    };
  }

  render() {
    const items = [
      {
        key: 1,
        label:
          "What information does AI Companionship collect during the User Acceptance Testing (UAT) period?",
        children:
          "AI Companionship collects data related to your chosen personality and interests’ settings, chat interactions, and ALICE GPT prompts.",
      },
      {
        key: 2,
        label: "How is my data used in AI Companionship?",
        children:
          "Your data enhances the AI companion's responses, tailoring them to your preferences for a personalized chat experience.",
      },
      {
        key: 3,
        label:
          "Where is my data stored, and how is it secured in AI Companionship's system?",
        children:
          "Just like any other information and data the company stores, your chat data is securely stored on our internal server. Security measures such as the JWT token concept with HmacSha512 are used to add extra protection, ensuring the confidentiality and integrity of your information within the company's servers.",
      },
      {
        key: 4,
        label: "Is my data shared with third parties in AI Companionship?",
        children:
          "No, your data remains confidential within our system and is not shared with third parties.",
      },
      {
        key: 5,
        label:
          "How can I delete my data from AI Companionship's database during the UAT period?",
        children: (
          <>
            Kindly send a request of data removal at any time to{" "}
            <a href="mailto:sameh@forest-interactive.com">
              sameh@forest-interactive.com
            </a>
          </>
        ),
      },
      {
        key: 6,
        label:
          "Can I be sure my data is only accessible to the UAT team in AI Companionship?",
        children:
          "Yes, your data is strictly confined to the UAT team with robust access controls.",
      },
      {
        key: 7,
        label:
          "How often is my data backed up, and what measures prevent data loss in AI Companionship?",
        children:
          "During the UAT testing launch, we're still finalizing data backup measures. It's crucial to note that this phase is experimental, and we strongly advise against relying on AI Companionship to store essential information. Please ensure critical data is backed up externally to avoid any potential loss.",
      },
      {
        key: 8,
        label:
          "What happens in case of a security breach during UAT in AI Companionship?",
        children:
          "For the testing phase, we will remove all conversation and user information in the unlikely event of a data breach. It is advised that users in the testing phase avoid sharing sensitive data that might be compromised if any unwanted events occur.",
      },
      {
        key: 9,
        label:
          "What are some examples of data that I should not share with my AI Companion?",
        children: (
          <>
            Be careful not to disclose to any of the following information when
            testing the AI Companionship:
            <ol>
              <li>
                Personal Identifiable Information (PII): This includes details
                such as full names, addresses, phone numbers, social security
                numbers, and other personally identifiable data.
              </li>
              <li>
                Financial Information: Avoid sharing credit card numbers, bank
                account details, or any other sensitive financial information.
              </li>
              <li>
                Passwords and Access Credentials: Never provide passwords, login
                credentials, or any information that could grant access to your
                accounts or systems. Health-related Information: Keep
                confidential details about your medical history, conditions, or
                any health-related issues private.
              </li>
              <li>
                Legal or Confidential Documents: Avoid sharing confidential
                legal documents, contracts, or any sensitive legal information.
              </li>
              <li>
                Business Information: Refrain from disclosing proprietary
                information, trade secrets, or any confidential business
                strategies.
              </li>
              <li>
                Private Conversations: Avoid sharing private conversations,
                especially those involving others who haven't consented to the
                disclosure.
              </li>
            </ol>
            This list isn't exhaustive. Exercise caution and use your judgment
            regarding the information shared during testing. Protect sensitive
            data responsibly.
          </>
        ),
      },
      {
        key: 10,
        label:
          "How does AI Companionship ensure the integrity and accuracy of my data during UAT?",
        children:
          "We will perform regular checks and validation of every data input made by the user to ensure they are accurate and integrated.",
      },
      {
        key: 11,
        label:
          "Are logs kept of individuals accessing my data within the testing team in AI Companionship?",
        children:
          "Yes, detailed access logs are maintained, ensuring accountability and responsible data handling.",
      },
      {
        key: 12,
        label:
          "Can I request a report on how my data contributed to improvements in AI Companionship's responses?",
        children:
          "You may request a report on the impact of your AI Companionship chats, but it is limited to 100 chats only. This is the maximum number of chats stored to ensure quality responses. Any additional chats beyond this limit are automatically removed.",
      },
      {
        key: 13,
        label:
          "Will my data be deleted once the UAT period concludes in AI Companionship?",
        children:
          "Your conversation data will be used to further train AI Companionship in the next development phase. However, you can opt out and have your account removed instead through the app settings.",
      },
      {
        key: 14,
        label:
          "How can users opt to remove their data during the UAT phase in AI Companionship?",
        children:
          "Users who would like to remove their data from the testing have the option to delete their account (All your user data will be permanently deleted upon removal.) in the Profile section. If you prefer to clear your chat conversations instead, you can select 'Clear Chat Conversation'.",
      },
      {
        key: 15,
        label: "What does ALICE GPT have to do with this?",
        children:
          "ALICE GPT powers the backend of AI Companionship, generating responses based on your preferences to create a personalized chat experience.",
      },
      {
        key: 16,
        label: "Is ALICE GPT safe?",
        children:
          "Yes, ALICE GPT is designed with safety in mind, and stringent measures are in place to ensure the secure handling of data during UAT.",
      },
      {
        key: 17,
        label:
          "How can I reach out for questions or concerns about my data privacy in AI Companionship?",
        children: (
          <>
            Contact our dedicated support team at
            <a href="mailto:creativeproduct@forest-interactive.com">
              creativeproduct@forest-interactive.com
            </a>{" "}
            for any privacy-related inquiries.
          </>
        ),
      },
    ];

    return (
      <div className={styles.faqs_page}>
        <div className={styles.faqs_wrapper}>
          <Typography.Title level={3}>
            Frequently Asked Questions (FAQs)
          </Typography.Title>
          <div className={styles.faqs_content}>
            <Collapse
              expandIconPosition="end"
              items={items}
              activeKey={this.state.activeKey}
              onChange={(key) => this.setState({ activeKey: key })}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FAQs;
